import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import CollegamentiGame from "./CollegamentiGame";

const Collegamenti = ({
  dateOverride = null,
  sessionOptions = null,
}) => {
  const { date: routeDate } = useParams();
  const date = dateOverride || routeDate;
  const gameConfig = getGameConfig("collegamenti");

  const {
    state: sessionState,
    puzzleConfig,
    solutions, // Only available when game is complete (won/lost)
    status,
    gameOver,
    won,
    lost,
    justLost,
    justWon, // True only when user wins during this session
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date, sessionOptions || {});
  return (
    <CollegamentiGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      status={status}
      gameOver={gameOver}
      won={won}
      lost={lost}
      justLost={justLost}
      justWon={justWon}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      isSignedIn={isSignedIn}
    />
  );
};

export default Collegamenti;
